import { Outlet, useLocation } from 'react-router-dom'
import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import Tile from '@/shared/components/Tile/Tile'
import Grid from '@/config/Grid/Grid'
import LoadingPage from '@/pages/LoadingPage'
import styles from '@/features/sales-reports/SalesReports.module.scss'

const TAB_VALUES = {
  MENU_ITEMS: 'menu-items',
  INVENTORY: 'inventory'
} as const

function SalesReports() {
  const { t } = useTranslation()
  const location = useLocation()

  const currentTab = location.pathname.includes(TAB_VALUES.INVENTORY)
    ? TAB_VALUES.INVENTORY
    : TAB_VALUES.MENU_ITEMS

  const description =
    currentTab === TAB_VALUES.INVENTORY
      ? t('SALES_REPORTS.DESCRIPTION.INVENTORY')
      : t('SALES_REPORTS.DESCRIPTION.MENU_ITEMS')

  return (
    <Grid>
      <div className={`${styles.salesReportContainer} start-2 col-11`}>
        <Tile color="black">
          <div className={styles.tileInner}>
            <p
              id="tour-reports-tabs"
              className={`title-bold-medium ${styles.title}`}
            >
              {t('REPORTS.TITLE')}
            </p>
            <p className={`body-medium ${styles.description}`}>{description}</p>
            <div className={styles.outletWrapper}>
              <Suspense fallback={<LoadingPage />}>
                <Outlet />
              </Suspense>
            </div>
          </div>
        </Tile>
      </div>
    </Grid>
  )
}

export default SalesReports
